var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import ModalWidget from './ModalWidget';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { actions as ChatbotV2Actions } from '../../../Slice/ChatbotV2Slice';
import { GilroyContext } from '../../GilroyContext';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .person-popup {\n\n  }\n"], ["\n  .person-popup {\n\n  }\n"])));
var defaultProps = {
    companyId: 0,
    personId: 0,
    isCompany: false,
    ispdf: 0,
    isAddCompany: false,
    isOnboarding: false,
    isSRICompany: false,
    isChatbotPopup: false,
    isSAP: false,
    // loading: false,
};
var ProfilePopups = function ProfilePopups(props) {
    var title = props.title, description = props.description, contactUs = props.contactUs, type = props.type, isDownloadPopup = props.isDownloadPopup, callToAction = props.callToAction, personId = props.personId, companyId = props.companyId, isCompany = props.isCompany, ispdf = props.ispdf, loading = props.loading, isAddCompany = props.isAddCompany, isOnboarding = props.isOnboarding, isSRICompany = props.isSRICompany, isChatbotPopup = props.isChatbotPopup, isSAP = props.isSAP;
    var _a = useContext(GilroyContext), gilroyActions = _a.gilroyActions, gilroyStates = _a.gilroyStates;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var personName = gilroyStates.personName;
    var companyProfile = gilroyStates.companyProfile;
    var defineClass = isCompany ? 'company-wrapper' : 'other-wrapper';
    var onClickContactUs = function () {
        var linkO = document.createElement('a');
        linkO.href = "mailto: ".concat(contactUs);
        linkO.dispatchEvent(new MouseEvent('click'));
    };
    var goBackToFeed = function () {
        if (isChatbotPopup) {
            dispatch(ChatbotV2Actions.resetChatbotPopup());
        }
        else if (isAddCompany) {
            gilroyActions.resetAddCompanyPopup();
        }
        else if (isOnboarding) {
            gilroyActions.resetAddCompanyPopup();
        }
        else if (isSRICompany) {
            gilroyActions.resetSRICompanyPopup();
        }
        else if (isCompany) {
            if (isDownloadPopup) {
                gilroyActions.setPDFProfile(null);
                gilroyActions.setPPTProfile(null);
                gilroyActions.resetCompanyProfilePopup();
            }
            else {
                gilroyActions.resetCompanyProfilePopup();
                navigate(-1);
            }
        }
        else if (isDownloadPopup) {
            var data = {
                isDownloadPopup: false,
                popupHeading: '',
                popupHtml: '',
                popupText: '',
                showPlanPopup: 0,
                allowFullView: false,
                contactusEmail: '',
            };
            gilroyActions.setPopupValues(data);
        }
        else if (isSAP) {
            gilroyActions.setShowLimitPopupSAP(false);
        }
        else {
            if (!personId)
                navigate(-1);
            gilroyActions.resetPersonPopups();
            // navigate('/feed/all/', { replace: true });
        }
    };
    var closeAccessRequiredPopup = function () {
        if (isCompany) {
            gilroyActions.resetCompanyProfilePopup();
            gilroyActions.setPDFProfile(null);
            gilroyActions.setPPTProfile(null);
        }
        else {
            gilroyActions.resetPersonPopups();
        }
    };
    var requestDownloadPopup = function () {
        if (isCompany) {
            if (companyId) {
                if (ispdf) {
                    var data = {
                        companyId: companyId,
                        ispdf: ispdf,
                        downloadRequest: 'true',
                        company_name: companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.companyName,
                    };
                    gilroyActions.getPDFProfile(data);
                }
                else {
                    var data = {
                        companyId: companyId,
                        ispdf: ispdf,
                        downloadRequest: 'true',
                        company_name: companyProfile === null || companyProfile === void 0 ? void 0 : companyProfile.companyName,
                    };
                    gilroyActions.getPPTProfile(data);
                }
            }
        }
        else if (personId) {
            var data = {
                personId: personId,
                downloadRequest: 'true',
                person_name: personName,
            };
            gilroyActions.getPersonProfileDownload(data);
        }
    };
    var scheduleDemo = function () {
        var linkO = document.createElement('a');
        linkO.href = "".concat(callToAction);
        linkO.target = '_blank';
        linkO.dispatchEvent(new MouseEvent('click'));
    };
    var emailsList = function () {
        var len = contactUs.split(',').length;
        return len > 1
            ? (_jsx(_Fragment, { children: contactUs.split(',').map(function (email, index) { return (index === len - 1
                    ? (_jsx("a", __assign({ href: "mailto:".concat(email), rel: "noreferrer" }, { children: email }))) : (_jsxs(_Fragment, { children: [_jsx("a", __assign({ href: "mailto:".concat(email), rel: "noreferrer" }, { children: email })), ",", _jsx("br", {})] }))); }) })) : _jsx("a", __assign({ href: "mailto:".concat(contactUs), rel: "noreferrer" }, { children: contactUs }));
    };
    var makeBold = function (item, keyword) {
        var re = new RegExp(keyword, 'g');
        return (item.replace(re, "<b>".concat(keyword, "</b>")));
    };
    var Popups = {
        1: (_jsx(ModalWidget, { nextText: "", title: title, description: description, onClickNext: onClickContactUs, onClickCancel: closeAccessRequiredPopup, closePopup: false, width: "530px", cancelText: "Cancel", nextLoading: false, wrapperClass: defineClass })),
        2: (_jsx(ModalWidget, { nextText: "Contact us", title: "", description: "", onClickNext: onClickContactUs, onClickCancel: goBackToFeed, closePopup: false, width: "530px", cancelText: "Cancel", nextLoading: false, wrapperClass: defineClass })),
        3: (_jsx(ModalWidget, __assign({ nextText: "Contact us", title: title, description: description, onClickNext: onClickContactUs, onClickCancel: goBackToFeed, closePopup: false, width: "530px", cancelText: "Cancel", nextLoading: false, wrapperClass: defineClass, isChatbotPopup: isChatbotPopup }, { children: emailsList() }))),
        4: (_jsx(ModalWidget, { nextText: "Request Download", title: title, description: makeBold(description, "'Request Download'"), onClickNext: requestDownloadPopup, onClickCancel: goBackToFeed, closePopup: false, width: "600px", cancelText: "", nextLoading: loading, wrapperClass: defineClass })),
        5: (_jsx(ModalWidget, __assign({ nextText: "Contact us", title: title, description: description, onClickNext: onClickContactUs, onClickCancel: goBackToFeed, closePopup: false, width: "530px", cancelText: "Cancel", nextLoading: false, wrapperClass: defineClass }, { children: emailsList() }))),
        // access required for generating content
        6: (_jsx(ModalWidget, { nextText: "Contact us", title: title, description: description, onClickNext: onClickContactUs, onClickCancel: closeAccessRequiredPopup, closePopup: false, width: "530px", cancelText: "Cancel", nextLoading: false, wrapperClass: defineClass })),
        // show a schedule demo popup
        8: (_jsx(ModalWidget, { nextText: "Schedule Demo", title: title, description: description, email: contactUs, onClickNext: scheduleDemo, onClickCancel: goBackToFeed, closePopup: false, width: "530px", cancelText: "Cancel", nextLoading: false, wrapperClass: defineClass })),
    };
    return (_jsx(Wrapper, { children: Popups[type] }));
};
ProfilePopups.defaultProps = defaultProps;
export default ProfilePopups;
var templateObject_1;
